import { useStore } from "../lib/store";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => {
  const { business } = useStore();
  return (
    <footer className="bg-ink text-white pt-20 pb-8" data-testid="site-footer">
      <div className="container-aura grid lg:grid-cols-12 gap-12">
        {/* Brand */}
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 flex items-center justify-center">
              <span className="font-serif text-xl text-gold">A</span>
            </div>
            <div>
              <div className="font-serif text-2xl">AURA</div>
              <div className="text-[10px] tracking-luxe uppercase text-white/60">Estética Corporal & Spa</div>
            </div>
          </div>
          <p className="text-sm text-white/60 leading-relaxed font-light max-w-md">
            {business.tagline} Un espacio creado por <span className="text-gold">{business.director}</span> para realzar tu belleza natural.
          </p>
          <div className="flex items-center gap-3 mt-7">
            <SocialIcon href={business.social?.instagram} icon={<Instagram size={16} />} label="instagram" />
            <SocialIcon href={business.social?.facebook} icon={<Facebook size={16} />} label="facebook" />
            <SocialIcon href={business.social?.tiktok} icon={
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.13a8.16 8.16 0 0 0 4.77 1.52V7.18a4.83 4.83 0 0 1-1.84-.49z"/></svg>
            } label="tiktok" />
          </div>
        </div>

        {/* Quick links */}
        <div className="lg:col-span-3">
          <div className="text-xs tracking-luxe uppercase text-gold mb-5">Enlaces</div>
          <ul className="space-y-3 text-sm text-white/70">
            {[
              ["inicio", "Inicio"],
              ["sobre-nosotros", "Sobre Nosotros"],
              ["servicios", "Servicios"],
              ["promociones", "Promociones"],
              ["galeria", "Galería"],
              ["reservas", "Reservar"],
            ].map(([id, label]) => (
              <li key={id}>
                <a href={`#${id}`} className="hover:text-gold transition-colors" data-testid={`footer-link-${id}`}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="lg:col-span-4">
          <div className="text-xs tracking-luxe uppercase text-gold mb-5">Contacto</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-gold mt-0.5 flex-shrink-0" />
              <span>{business.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-gold mt-0.5 flex-shrink-0" />
              <span>{business.whatsapp}</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-gold mt-0.5 flex-shrink-0" />
              <span>{business.email}</span>
            </li>
          </ul>
          <div className="mt-6 pt-6 border-t border-white/10">
            <div className="text-xs tracking-luxe uppercase text-white/40 mb-2">Horarios</div>
            <div className="space-y-1 text-xs text-white/60">
              {business.hours?.map((h, i) => (
                <div key={i} className="flex justify-between">
                  <span>{h.day}</span>
                  <span className="text-white/80">{h.time}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container-aura mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/40">
        <div>© {new Date().getFullYear()} AURA Estética Corporal & Spa — Todos los derechos reservados.</div>
        <div>
          Diseñado con <span className="text-gold">♡</span> para Zaida Meléndez ·{" "}
          <a href="/admin" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Admin</a>
        </div>
      </div>
    </footer>
  );
};

const SocialIcon = ({ href, icon, label }) => (
  <a
    href={href || "#"}
    target="_blank"
    rel="noreferrer"
    aria-label={label}
    data-testid={`social-${label}`}
    className="w-10 h-10 rounded-full border border-white/20 hover:border-gold hover:bg-gold hover:text-ink flex items-center justify-center text-white/70 transition-all"
  >
    {icon}
  </a>
);
